import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import QSection from "../../components/questionPage/QSection";
import SideBar from "../../layout/SideBar";
import BreakPoints from "../../BreakPoints";
import QAside from "../../components/questionPage/QAside";
import QuestionsPageProvider from "../../context/QuestionsPageContext";
import QContent from "../../components/questionPage/QContent";

export default function QuestionsPage() {
  const { xSmall, small, medium, large, xLarge, xXLarge } = BreakPoints();


  return (
    <>
      <div className={`questions-page-container page-h`}>
        {!medium && !large ? <Header /> : <SideBar />}

        {(xLarge || xXLarge) && <QSection />}
        <QuestionsPageProvider>
          <QContent />
          <QAside />
        </QuestionsPageProvider>

        {(small || xSmall) && <Footer />}
      </div>
    </>
  );
}
